module.exports = __webpack_public_path__ + "img/11069862_L.23d0cd11.png";